import { useCallback } from 'react';
import { SITE } from '@/app/constants';
import { safeStorage } from '@/app/utils/client';
import { useGlobalModal } from './use-global-modal';

// const LOCAL_STORAGE_CONFIRMATION_SHOWN_KEY = 'VIDU_DOWNLOAD_WATERMARK_CONFIRMATION_SHOWN';

const LOCAL_STORAGE_CONFIRMATION_SHOWN_KEY_V2 = 'LOCAL_STORAGE_CONFIRMATION_SHOWN_KEY_V2';

/**
 * 处理国内站无水印下载的弹窗提醒逻辑
 */
export const useWatermarkConfirmation = () => {
  const { open: openConfirmDialog } = useGlobalModal('confirmDialog');

  /**
   * 处理无水印下载（包含弹窗确认逻辑）
   * @param onConfirm 弹窗确认后的回调
   */
  const handleNoWatermarkAction = useCallback(
    (onConfirm?: () => void | Promise<void>) => {
      // 国内首次点击时才弹窗，其他情况直接执行回调
      if (SITE !== 'china' || safeStorage.getItem(LOCAL_STORAGE_CONFIRMATION_SHOWN_KEY_V2)) {
        onConfirm?.();
        return;
      }
      // 显示确认弹窗
      openConfirmDialog({
        title: '关于AI生成水印的提示',
        content: (
          <>
            <p>为保障创作透明与合规，系统默认保留并展示水印。</p>
            <p>除素材权利方要求不得删除水印的情况外，您可根据需要选择是否移除水印。</p>
          </>
        ),
        primaryButtonText: '好的',
        onPrimaryAction: () => {
          safeStorage.setItem(LOCAL_STORAGE_CONFIRMATION_SHOWN_KEY_V2, 'true');
          onConfirm?.();
        },
      });
    },
    [openConfirmDialog],
  );

  return {
    handleNoWatermarkAction,
  };
};
